import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { workflowsAllowedEmails } from '@agilox/common';
import { UserStoreService } from '@user-store';
import { MenuPointUrl } from '../models/enums/menupoint-url.enum';

export const workflowsGuard: CanActivateFn = (): boolean | UrlTree => {
	const userStore = inject(UserStoreService);
	const router = inject(Router);
	const user = userStore.currentUser();

	const hasAccess = user?.email && workflowsAllowedEmails.includes(user.email.toLowerCase());

	if (hasAccess) {
		return true;
	}

	return router.parseUrl(MenuPointUrl.DASHBOARD);
};
